import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';

export const enableB2BOverquotaFlow = (IS_BIZ_USER && isFeature('enable-b2b-overquota-flow')) || false;
